import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { scrollToSection, BANDS_SECTION_ID } from '../utils/scroll';
type CtaButtonProps = {
  label?: string;
  className?: string;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'outline';
  /** Section id the CTA scrolls to. Defaults to the band overview. */
  targetId?: string;
  /** Only used once a checkout URL is configured. */
  href?: string | null;
  showArrow?: boolean;
};
export function CtaButton({
  label = 'Die 6 Bände entdecken',
  className = '',
  size = 'lg',
  variant = 'primary',
  targetId = BANDS_SECTION_ID,
  href = null,
  showArrow = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'min-h-[52px] px-7 py-3.5 text-base sm:text-[17px]' : 'min-h-[52px] px-6 py-3 text-[15px] sm:text-base';
  const tone = variant === 'primary' ? 'bg-[#20c65a] text-white shadow-lg shadow-[#20c65a]/25 hover:bg-[#17a94a] focus-visible:outline-[#20c65a]' : 'border-2 border-gold/60 text-gold hover:border-gold hover:bg-gold/10 focus-visible:outline-gold';
  const baseClass = `inline-flex w-full items-center justify-center gap-2 rounded-xl font-display font-extrabold tracking-wide transition-[transform,background-color,border-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 active:translate-y-0 ${tone} ${sizing} ${className}`;
  const content = <>
      {label}
      {showArrow && <ArrowRightIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-64" data-mp="3sxdhmz249vq3" />}
    </>;
  if (href) {
    return <a href={href} className={baseClass} data-id="element-65" data-mp="1io8hdbksdxb">
        {content}
      </a>;
  }
  return <a href={`#${targetId}`} onClick={event => {
    event.preventDefault();
    scrollToSection(targetId);
  }} className={baseClass} data-id="element-66" data-mp="6ikf7kbnqjgk">
      {content}
    </a>;
}